<template>
<div class="chapter">
<div class="inner_page">
<h1 class="AHD">Buttercream Basics</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1.vue?27b9a0b5